export type ICurrencyTone = "gold" | "silver" | "neutral"

export interface ICurrencyPresentation {
  order: number
  tone: ICurrencyTone
  hasAddButton: boolean
}

const CURRENCY_PRESENTATION: Readonly<Record<string, ICurrencyPresentation>> = {
  premium: { order: 0, tone: "gold", hasAddButton: true },
  soft: { order: 1, tone: "silver", hasAddButton: false }
}

export const CURRENCY_DISPLAY_ORDER: readonly string[] = Object.keys(
  CURRENCY_PRESENTATION
).sort(
  (a, b) => CURRENCY_PRESENTATION[a].order - CURRENCY_PRESENTATION[b].order
)

const NEUTRAL_PRESENTATION: ICurrencyPresentation = {
  order: CURRENCY_DISPLAY_ORDER.length,
  tone: "neutral",
  hasAddButton: false
}

export const presentationOf = (code: string): ICurrencyPresentation =>
  Object.hasOwn(CURRENCY_PRESENTATION, code)
    ? CURRENCY_PRESENTATION[code]
    : NEUTRAL_PRESENTATION

const rankOf = (code: string, order: readonly string[]): number => {
  const index = order.indexOf(code)
  return index === -1 ? order.length : index
}

export const compareCurrencyCodes = (
  a: string,
  b: string,
  order: readonly string[]
): number => rankOf(a, order) - rankOf(b, order) || (a < b ? -1 : a > b ? 1 : 0)

export const sortCurrencyCodes = (
  codes: readonly string[],
  order: readonly string[]
): string[] => [...codes].sort((a, b) => compareCurrencyCodes(a, b, order))
